import { configureStore } from "@reduxjs/toolkit";
import moreThan768Reducer from "store/slices/moreThan768Slice";
import loadingReducer from "store/slices/loadingSlice";

const store = configureStore({
    reducer: {
        moreThan768: moreThan768Reducer,
        loading: loadingReducer
    }
});

export default store;

